import { useEffect } from 'react';

export const useChangeHeadTitle = (title: string) => {
  useEffect(() => {
    const [titleElement] = document.getElementsByTagName('title');
    titleElement.innerHTML = title;
  }, [title]);
};
